var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getJson, RESOLVE_DYNAMIC_DATA_HEADER } from '../server';
import { setPhrases } from '../Translate';
import { appShellDataUrl, getAppShellDataFromCache, saveAppShellData } from './utils';
import * as crossWindowEvents from '../cross-window-events';
import { dispatchScopeEvent as scopeEventDispatch } from '../events';
import { resolveComponentAndChildComponents } from '../resolve-component';
export const UPDATE_APP_SHELL_DATA = 'UPDATE_APP_SHELL_DATA';
export function updateAppShellData(isCurrentBrowserTab = true, resolveDynamicData = true) {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        const headers = resolveDynamicData ? { [RESOLVE_DYNAMIC_DATA_HEADER]: 'true' } : undefined;
        const appShellData = yield getJson(appShellDataUrl, headers);
        saveAppShellData(appShellData);
        yield handleNewAppShellData(appShellData, dispatch);
        if (isCurrentBrowserTab) {
            crossWindowEvents.emitCrossWindowWithData({
                name: 'update-appshelldata',
                data: appShellData,
                runImmediately: true,
            });
        }
    });
}
export function updateAppShellDataFromSlowCache() {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        const appShellData = yield getAppShellDataFromCache();
        if (!appShellData) {
            return;
        }
        yield handleNewAppShellData(appShellData, dispatch);
    });
}
function handleNewAppShellData(appShellData, dispatch) {
    return __awaiter(this, void 0, void 0, function* () {
        setPhrases(appShellData.languagePhrases);
        yield resolveComponentAndChildComponents(appShellData, appShellData.currentTheme);
        const updateAppShellDataAction = {
            type: UPDATE_APP_SHELL_DATA,
            appShellData,
        };
        scopeEventDispatch(updateAppShellDataAction);
        dispatch(updateAppShellDataAction);
    });
}
export function initUpdateAppShellDataOnSchedule(store, automaticReloadInSeconds = 5 * 60) {
    let updateOnNextVisible = false;
    setInterval(() => {
        if (!document.hidden) {
            store.dispatch(updateAppShellData());
        }
        else {
            updateOnNextVisible = true;
        }
    }, automaticReloadInSeconds * 1000);
    document.addEventListener('visibilitychange', () => {
        if (updateOnNextVisible && !document.hidden) {
            store.dispatch(updateAppShellData());
            updateOnNextVisible = false;
        }
    }, false);
}
crossWindowEvents.onCrossWindow('update-appshelldata', (store, data) => __awaiter(void 0, void 0, void 0, function* () {
    yield handleNewAppShellData(data, store.dispatch);
}));
